import type { CSSProperties } from 'react'

interface EditedBadgeProps {
  style?: CSSProperties
}

/**
 * Black "Edited" pill, mono, small.
 * Use on rows whose value has been modified (Rule 09).
 */
export function EditedBadge({ style }: EditedBadgeProps): JSX.Element {
  return (
    <span
      data-testid="edited-badge"
      style={{
        background: 'var(--text)',
        color: 'var(--surface)',
        fontFamily: 'var(--font-mono)',
        fontSize: 9,
        padding: '2px 7px',
        borderRadius: 3,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      Edited
    </span>
  )
}
